import AbsComponent from "../AbsComponent";

class AbsItemList extends AbsComponent{
    constructor(_name='', _store={}, _router={}, _el=''){
        super(_name, _store, _router, _el);
        this.dbParam = '';

        let watchLoadStatus = this.watch(this.store.getState, 'loadStatusItemList', this.isEqual);
        this.store.subscribe( watchLoadStatus( (newVal, oldVal, path) => this.loadStatus(newVal, oldVal, path)));

        let watchListPage = this.watch(this.store.getState, 'listPage', this.isEqual);
        this.store.subscribe( watchListPage( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path, newVal)));

        let watchItemList = this.watch(this.store.getState, 'itemList', this.isEqual);
        this.store.subscribe( watchItemList( (newVal, oldVal, path) => this.render(newVal, oldVal, path)));
        
        let watchItemListTitle = this.watch(this.store.getState, 'itemListTitle', this.isEqual);
        this.store.subscribe( watchItemListTitle( (newVal, oldVal, path) => $(this.el + ' .gd-search-result-title>span:first-child').html(newVal) ));

        let watchQuery = this.watch(this.store.getState, 'query', this.isEqual);
        this.store.subscribe( watchQuery( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path)));
    }

    render(_newVal, _oldVal, _path){
        $(this.el + ' .gd-search-result').toggleClass('is-no-result', (_newVal.data.length<1));
        $(this.el + ' .gd-search-result-title em').toggle(_newVal.totalCount>=0).text((_newVal.totalCount>999)? '999+': _newVal.totalCount);
        if (_newVal.errMessage) {
            $('.gd-no-result-wrap .gd-no-result').html(`
                <strong class="gd-no-result-main-text">죄송합니다. 일시적인 오류가 발생하였습니다.</strong>
                <span class="gd-no-result-sub-text">잠시 후 다시 이용해 주세요.</span>`
            );
            return false;
        }
        if (_newVal.data.length<1) {
            $('.gd-no-result-wrap .gd-no-result').html(`
                <strong class="gd-no-result-main-text">검색 결과가 없습니다.</strong>
                <span class="gd-no-result-sub-text"></span>
                <span class="gd-no-result-sub-text">검색어와 검색 조건이 정확한지 확인해 주세요.<br>
                원하는 정보가 없다면 <a href="/search/index?site=lineage2&amp;query=${encodeURIComponent(this.store.getState().query)}">통합 검색</a>에서 더 다양한 정보를 확인해 보세요.</span>`
            );

            if ( !this.store.getState().isUserSelect && _newVal.page==1 ) {
                this.store.dispatch( this.actions.setDetail({time: +new Date()}) );
                this.store.dispatch( this.actions.loadStatusDetail('isLoadComp') );
            }
            return false;
        }

        if (_newVal.data.length>0) {
            let list = _newVal.data.map( it => this.singleObj(it) );
            $(this.el + ' .gd-result-list').empty().append( list );

            if ( !this.store.getState().isUserSelect && _newVal.page==1 ) {
                this.router.goSingleParam( this.dbParam, list[0].data('id') );
                list[0].addClass("is-active");
            }   
        }
    }

    singleObj(it){}

    selChange(_newVal, _oldVal, _path, _pageNum=1){
        if(this.store.getState().stopListLoad) return;
        this.store.dispatch( this.actions.loadItemList(_pageNum) );
    }

    loadStatus(_newVal, _oldVal, _path){
        $('.gd-search-result-title .gd-loading-circle').toggle(_newVal==='isLoading');
    }

} // end of class
export default AbsItemList;